import { Component, OnInit } from '@angular/core';
import { PackageService } from '@services/packages/package.service';

@Component({
    selector: 'app-customers-list',
    templateUrl: './customers-list.component.html',
    styleUrls: ['./customers-list.component.scss'],
    providers: [PackageService],
    standalone: false
})
export class CustomersListComponent implements OnInit {
  public params: any;
  destinationNamesById = {};

  public columns = [
    { prop: 'combinedAddressCached.title', name: 'Title' },
    { prop: 'combinedAddressCached.website', name: 'Website' },
    { prop: 'combinedAddressCached.email', name: 'Email' },
    { prop: 'combinedAddressCached.phone', name: 'Phone' },
    { prop: 'combinedAddressCached.fax', name: 'Fax' },
    { prop: 'combinedAddressCached.street', name: 'Address' },
    { prop: 'combinedAddressCached.zip', name: 'Zip' },
    { prop: 'combinedAddressCached.city', name: 'City' },
    { prop: '', name: 'Destination' },
    {
      prop: 'tweebie', name: 'Type', valueTransformer: data => {
        if (data) {
          if (data.isDestination) {
            return 'Destination';
          } else {
            return 'Accommodation';
          }
        } else {
          return '';
        }
      }
    },
    {
      prop: 'tweebie', name: 'Subtype', valueTransformer: data => {
        if (data) {
          if (data.isDestination) {
            return '';
          }
          if (data.accommodationType) {
            if (data.accommodationType === 'holidayHome') {
              return 'Holiday Home';
            } else {
              return 'Hotel';
            }
          } else {
            return 'Hotel';
          }
        } else {
          return '';
        }
      }
    },
    { prop: 'tweebie.matchIds.hotellerie-suisse', name: 'hotel_id' }
  ];

  constructor(public packageService: PackageService) {
    packageService.find(0, 100, {
      'tweebie.isDestination': true
    }).then(result => {
      for (const destination of result.data) {
        this.destinationNamesById[destination._id] = destination.title;
      }
      this.columns[8] = {
        prop: 'tweebie.destinationId', name: 'Destination', valueTransformer: data => {
          if (data) {
            return this.destinationNamesById[data];
          } else {
            return '';
          }
        }
      }
    })
  }

  ngOnInit() {

  }

}
